import React from 'react';
import { connect } from 'react-redux';
import { EntityType } from '../../entities/common';
import { actionCreators } from '../../store/CalendarsListStore';
import ListEntityWithNameCreation from '../common/ListEntityWithNameCreation';

type OwnProps = {
    onDismiss: () => void;
};

type Props = OwnProps & typeof actionCreators;

const CalendarCreation = (props: Props) => {
    const onSave = React.useCallback((name: string) => props.createCalendar(name), [props.createCalendar]);

    return (
        <ListEntityWithNameCreation
            entityType={EntityType.Calendar}
            header={{
                secondaryText: `Fill in the Calendar Name field below to create a new global Calendar.
                    You will be able to provide Calendar details later.`
            }}
            onSave={onSave}            
            onDismiss={props.onDismiss}
        />
    );
}

export default connect(undefined, actionCreators)(CalendarCreation);